import { isAsyncThunkAction, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { hideLoader, showLoader } from './uiSlice';

const debounceFactory = (delay = 300) => {
    let timer;
    return (fn) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(), delay);
    };
};

const debounce = debounceFactory(500);

const uiLoaderInterceptor = (storeAPI) => (next) => (action) => {
    if (isAsyncThunkAction(action)) {
        if (isPending(action)) {
            if (!storeAPI.getState().UI.loading) {
                storeAPI.dispatch(showLoader());
            }
            next(action);
        }

        if (isFulfilled(action) || isRejected(action)) {
            next(action);
            debounce(() => storeAPI.dispatch(hideLoader()));
        }
    } else {
        next(action);
    }
};

const UIMiddlewares = [uiLoaderInterceptor];
export default UIMiddlewares;
